import Vue from 'vue'
import Router from 'vue-router'
import publicHome from '@/components/home'
import home from '@/views/home'
import towait from '@/views/home/towait'
import test from '@/views/test'
import details from '@/views/home/details'
import login from '@/views/login'
//公共页面
import publicHtml from '@/components/public'

import shopJs from './shop.js'
import commodityJs from './commodity.js'
import financialJs from './financial.js'
import learningJs from './learning.js'
import settingJs from './setting.js'
import storesJs from './stores.js'
Vue.use(Router)

export default new Router({
	scrollBehavior (to, from, savedPosition) {
	 // return 期望滚动到哪个的位置
	 return { x: 0, y: 0 }
	},
  routes: [
		{
      path: '/',
      name: 'publicHome',
      component: publicHome,
			redirect:'home',
			children:[
				{
				  path: '/',
				  name: 'home',
				  component: home
				},
				{
				  path: '/details',
				  name: 'details',
					meta:[{name:'清单详情'}],
				  component: details
				},
				{
				  path: '/towait',
				  name: 'towait',
				  component: towait
				},
			]
    },
		{
      path: '/login',
      name: 'login',
      component: login
    },
		{
      path: '/payment',
      name: 'payment',
      component: resolve => require(['@/views/payment/index'], resolve)
    },
		{
      path: '/shop/orderNew',
      name: 'orderNew',
      component: resolve => require(['@/views/shop/orderNew'], resolve)
    },
		{
      path: '/shop/orderNew/orderDetailsNew',
      name: 'orderDetailsNew',
      component: resolve => require(['@/views/shop/orderDetailsNew'], resolve)
    },	
		{
      path: '/shop/orderNew/orderDetails1New',
      name: 'orderDetails1New',
      component: resolve => require(['@/views/shop/Orderdetails1New'], resolve)
    },
			
		{
      path: '/publicHtml',
      name: 'publicHtml',
      component: publicHtml,
			children:[
				...shopJs,
				...commodityJs,
				...financialJs,
				...learningJs,
				...settingJs,
				...storesJs
			]
    },
		{
			path: '/test',
			name: 'test',
			component: test
		},		
		{
      path: "*",
      redirect: "/"
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js